// ===== SWEDISH PERFUME CATALOG - COMPLETE WITH ALL REAL BRANDS =====
// Save as: assets/perfume-catalog-swedish.js
// TOTAL: 78 Real Perfumes with correct images from your site

window.SwedishPerfumeCatalog = {
  // ===== MAISON FRANCIS KURKDJIAN =====
  maisonFrancisKurkdjian: [
    {
      id: "mfk_baccarat_rouge_540",
      name: "Baccarat Rouge 540",
      brand: "Maison Francis Kurkdjian",
      image: "https://tryscent.co/cdn/shop/files/rouge_540.jpg?v=1773051631",
      top_notes: ["Saffran", "Jasmin"],
      heart_notes: ["Ceder", "Amberträ"],
      base_notes: ["Ambroxan", "Ethyl Maltol", "Amber"],
      description: "En ikonisk och lyxig doft som fångar kristallens alkemi.",
      year: "2015",
      gender: "Unisex",
      productNumbers: ["466"]
    }
  ],

  // ===== TOM FORD =====
  tomFord: [
    {
      id: "tom_ford_lost_cherry",
      name: "Lost Cherry",
      brand: "Tom Ford",
      image: "https://tryscent.co/cdn/shop/files/lost_cherry.jpg?v=1763008550",
      top_notes: ["Körsbär", "Mandel", "Likör"],
      heart_notes: ["Körsbär", "Ros", "Jasmin"],
      base_notes: ["Vanilj", "Benzoin", "Ceder"],
      description: "En förförisk och lekfull doft som fångar essensen av en förbjuden frukt.",
      year: "2018",
      gender: "Unisex",
      productNumbers: ["438"]
    },
    {
      id: "tom_ford_vanille_fatale",
      name: "Vanille Fatale",
      brand: "Tom Ford",
      image: "https://tryscent.co/cdn/shop/files/Tom_Ford_Vanille_Fatale.avif?v=1763048895",
      top_notes: ["Saffran", "Neroli", "Bergamott"],
      heart_notes: ["Vanilj", "Kaffe", "Läder"],
      base_notes: ["Amber", "Myrra", "Benzoin"],
      description: "En mörk och berusande vaniljdoft.",
      year: "2017",
      gender: "Unisex",
      productNumbers: ["053"]
    },
    {
      id: "tom_ford_tobacco_vanille",
      name: "Tobacco Vanille",
      brand: "Tom Ford",
      image: "https://tryscent.co/cdn/shop/files/tobacco_vanille.jpg?v=1763008550",
      top_notes: ["Tobak", "Kryddor"],
      heart_notes: ["Vanilj", "Kakao", "Tonka"],
      base_notes: ["Torkad frukt", "Tränoter"],
      description: "En varm och kryddig doft med rika tobaks- och vaniljnoter.",
      year: "2007",
      gender: "Unisex",
      productNumbers: ["193"]
    },
    {
      id: "tom_ford_fucking_fabulous",
      name: "Fucking Fabulous",
      brand: "Tom Ford",
      image: "https://tryscent.co/cdn/shop/files/Fabulous_Tom_Ford.avif?v=1763047131",
      top_notes: ["Salvia", "Lavendel"],
      heart_notes: ["Läder", "Mandel", "Vanilj"],
      base_notes: ["Tonka", "Amber", "Tränoter"],
      description: "En djärv, provokativ doft med läder- och mandeltoner.",
      year: "2017",
      gender: "Unisex",
      productNumbers: ["232"]
    },
    {
      id: "tom_ford_ombre_leather",
      name: "Ombre Leather",
      brand: "Tom Ford",
      image: "https://tryscent.co/cdn/shop/files/Tom_Ford_Ombre_Leather.avif?v=1763008490",
      top_notes: ["Kardemumma", "Jasmin", "Immortelle"],
      heart_notes: ["Läder", "Patchouli", "Viol"],
      base_notes: ["Amber", "Björktjära", "Mysk"],
      description: "En djärv och sensuell doft som hyllar läder.",
      year: "2018",
      gender: "Unisex",
      productNumbers: ["474"]
    },
    {
      id: "tom_ford_oud_wood",
      name: "Oud Wood",
      brand: "Tom Ford",
      image: "https://tryscent.co/cdn/shop/files/Tom_Ford_Oud_Wood.avif?v=1763049069",
      top_notes: ["Rosenved", "Kardemumma", "Peppar"],
      heart_notes: ["Sandelträ", "Vetiver", "Oud"],
      base_notes: ["Tonka", "Amber", "Vanilj"],
      description: "En mystisk och exotisk blandning av sällsynt oud-trä.",
      year: "2007",
      gender: "Unisex",
      productNumbers: ["287"]
    },
    {
      id: "tom_ford_noir_extreme",
      name: "Noir Extreme",
      brand: "Tom Ford",
      image: "https://tryscent.co/cdn/shop/files/Noir_Extreme.webp?v=1772215888",
      top_notes: ["Mandarin", "Kardemumma", "Ingefära"],
      heart_notes: ["Saffran", "Mysk", "Kryddnejlika"],
      base_notes: ["Vanilj", "Sandelträ", "Tonka"],
      description: "En rik, kryddig och gourmand-orientalisk doft.",
      year: "2015",
      gender: "Male",
      productNumbers: ["286"]
    },
    {
      id: "tom_ford_ombre_nomade",
      name: "Ombre Nomade",
      brand: "Tom Ford",
      image: "https://tryscent.co/cdn/shop/files/Tom_Ford_Ombre_Nomade.avif?v=1763008490",
      top_notes: ["Raspberry", "Saffron", "Rose", "Oud"],
      heart_notes: ["Incense", "Birch", "Leather", "Geranium"],
      base_notes: ["Amberwood", "Benzoin", "Oud", "Smoky Notes"],
      description: "En mörk, dramatisk och förförisk doft som kombinerar rik ros med djup, rökig oud. Ombre Nomade är en kraftfull och lyxig komposition som lämnar ett bestående intryck, perfekt för kvällar och speciella tillfällen.",
      year: "2018",
      gender: "Unisex",
      productNumbers: ["286"]
    }
  ],

  // ===== YVES SAINT LAURENT =====
  ysl: [
    {
      id: "ysl_black_opium",
      name: "Black Opium",
      brand: "Yves Saint Laurent",
      image: "https://tryscent.co/cdn/shop/files/ysl-black-opium-edp_jtgB.webp?v=1763008550",
      top_notes: ["Kaffe", "Rosa Peppar", "Apelsinblomma"],
      heart_notes: ["Jasmin", "Bittermandel", "Lakrits"],
      base_notes: ["Vanilj", "Ceder", "Patchouli"],
      description: "En djärv och kantig doft som fångar rockkulturens anda.",
      year: "2014",
      gender: "Female",
      productNumbers: ["132"]
    },
    {
      id: "ysl_libre",
      name: "Libre",
      brand: "Yves Saint Laurent",
      image: "https://tryscent.co/cdn/shop/files/Yves_Saint_Laurent_Libre.avif?v=1763048956",
      top_notes: ["Lavendel", "Bergamott", "Mandarin"],
      heart_notes: ["Apelsinblomma", "Jasmin", "Ros"],
      base_notes: ["Vanilj", "Amber", "Mysk"],
      description: "En fri och djärv doft för den självsäkra kvinnan.",
      year: "2019",
      gender: "Female",
      productNumbers: ["034"]
    },
    {
      id: "ysl_manifesto",
      name: "Manifesto",
      brand: "Yves Saint Laurent",
      image: "https://tryscent.co/cdn/shop/files/Yves_Saint_Laurent_Manifesto.webp?v=1772214721",
      top_notes: ["Gröna noter", "Bergamott", "Persika"],
      heart_notes: ["Jasmin", "Liljekonvalj", "Apelsinblomma"],
      base_notes: ["Vanilj", "Ceder", "Mysk", "Tonka"],
      description: "En varm, träig och samtidigt fräsch doft.",
      year: "2012",
      gender: "Female",
      productNumbers: ["134"]
    },
    {
      id: "ysl_opium",
      name: "Opium",
      brand: "Yves Saint Laurent",
      image: "https://tryscent.co/cdn/shop/files/Opium_Eau_de_Parfum.webp?v=1772215163",
      top_notes: ["Mandarin", "Plommon", "Kryddnejlika", "Koriander"],
      heart_notes: ["Kryddnejlika", "Ros", "Jasmin", "Liljekonvalj"],
      base_notes: ["Opium", "Myrra", "Amber", "Sandelträ"],
      description: "En legendarisk orientalisk doft som är både kryddig och sinnlig.",
      year: "1977",
      gender: "Female",
      productNumbers: ["083"]
    },
    {
      id: "ysl_y",
      name: "Y",
      brand: "Yves Saint Laurent",
      image: "https://tryscent.co/cdn/shop/files/Yves_Saint_Laurent_Y.avif?v=1763008490",
      top_notes: ["Bergamott", "Ingefära", "Aldehyder"],
      heart_notes: ["Salvia", "Enebär", "Geranium"],
      base_notes: ["Amber", "Ceder", "Mysk"],
      description: "En frisk och träig doft som representerar en ny generation.",
      year: "2017",
      gender: "Male",
      productNumbers: ["283"]
    }
  ],

  // ===== VALENTINO =====
  valentino: [
    {
      id: "valentino_donna_born_in_roma",
      name: "Donna Born in Roma",
      brand: "Valentino",
      image: "https://tryscent.co/cdn/shop/files/born_in_roma.jpg?v=1763008550",
      top_notes: ["Svarta vinbär", "Bergamott", "Jasmin"],
      heart_notes: ["Ros", "Jasmin", "Ceder"],
      base_notes: ["Vanilj", "Mysk", "Ceder"],
      description: "En modern och kantig doft som fångar den romerska ungdomskulturens anda.",
      year: "2019",
      gender: "Female",
      productNumbers: ["469"]
    },
    {
      id: "valentino_uomo_born_in_roma",
      name: "Uomo Born in Roma",
      brand: "Valentino",
      image: "https://tryscent.co/cdn/shop/files/Uomo_Born_in_Roma.webp?v=1772213958",
      top_notes: ["Mandarin", "Salt", "Mynta"],
      heart_notes: ["Lavendel", "Salvia", "Ceder"],
      base_notes: ["Vanilj", "Tonka", "Mysk"],
      description: "En frisk och aromatisk doft för den moderna mannen.",
      year: "2019",
      gender: "Male",
      productNumbers: ["360"]
    }
  ],

  // ===== PRADA =====
  prada: [
    {
      id: "prada_paradoxe",
      name: "Paradoxe",
      brand: "Prada",
      image: "https://tryscent.co/cdn/shop/files/Prada_Paradoxe.avif?v=1763048923",
      top_notes: ["Päron", "Bergamott", "Mandarin"],
      heart_notes: ["Apelsinblomma", "Jasmin", "Ros"],
      base_notes: ["Vanilj", "Amber", "Ceder"],
      description: "En modern och paradoxal doft som leker med kontraster.",
      year: "2022",
      gender: "Female",
      productNumbers: ["437"]
    },
    {
      id: "prada_candy",
      name: "Candy",
      brand: "Prada",
      image: "https://tryscent.co/cdn/shop/files/Prada_Candy.webp?v=1772214966",
      top_notes: ["Karamell", "Mysk", "Vanilj"],
      heart_notes: ["Benzoin", "Mysk"],
      base_notes: ["Vanilj", "Mysk", "Karamell"],
      description: "En lekfull och njutbar gourmand-doft.",
      year: "2011",
      gender: "Female",
      productNumbers: ["182"]
    }
  ],

  // ===== CAROLINA HERRERA =====
  carolinaHerrera: [
    {
      id: "carolina_good_girl",
      name: "Good Girl",
      brand: "Carolina Herrera",
      image: "https://tryscent.co/cdn/shop/files/Good_Girl_Velvet_Fatale.webp?v=1772223549",
      top_notes: ["Plommon", "Saffran", "Bergamott"],
      heart_notes: ["Tuberos", "Jasmin", "Apelsinblomma"],
      base_notes: ["Läder", "Vanilj", "Patchouli", "Tonka"],
      description: "En förförisk och mystisk doft som fångar dualiteten hos en modern kvinna.",
      year: "2016",
      gender: "Female",
      productNumbers: ["461"]
    },
    {
      id: "carolina_very_good_girl",
      name: "Very Good Girl",
      brand: "Carolina Herrera",
      image: "https://tryscent.co/cdn/shop/files/Very_Good_Girl.webp?v=1772215421",
      top_notes: ["Hallon", "Svarta vinbär", "Litchi"],
      heart_notes: ["Ros", "Tuberos", "Apelsinblomma"],
      base_notes: ["Vanilj", "Tonka", "Ceder"],
      description: "En djärv och fräsch tolkning av den ikoniska Good Girl-doften.",
      year: "2020",
      gender: "Female",
      productNumbers: ["404"]
    }
  ],

  // ===== CHANEL =====
  chanel: [
    {
      id: "chanel_bleu",
      name: "Bleu de Chanel",
      brand: "Chanel",
      image: "https://tryscent.co/cdn/shop/files/chanel_bleu.jpg?v=1763008550",
      top_notes: ["Grapefrukt", "Citron", "Mynta", "Rosa Peppar"],
      heart_notes: ["Ingefära", "Muskot", "Jasmin"],
      base_notes: ["Rökelse", "Vetiver", "Ceder", "Sandelträ"],
      description: "En tidlös och sofistikerad doft för män som förkroppsligar frihetens anda.",
      year: "2010",
      gender: "Male",
      productNumbers: ["252"]
    },
    {
      id: "chanel_allure_homme_sport",
      name: "Allure Homme Sport",
      brand: "Chanel",
      image: "https://tryscent.co/cdn/shop/files/Allure_Homme_Sport.webp?v=1772215015",
      top_notes: ["Mandarin", "Citron", "Bergamott"],
      heart_notes: ["Peppar", "Ceder", "Havsnoter"],
      base_notes: ["Mysk", "Amber", "Tonka"],
      description: "En frisk och sportig doft för den dynamiska mannen.",
      year: "2004",
      gender: "Male",
      productNumbers: ["222"]
    },
    {
      id: "chanel_coco_mademoiselle",
      name: "Coco Mademoiselle",
      brand: "Chanel",
      image: "https://tryscent.co/cdn/shop/files/Chanel_Coco_Mademoiselle.avif?v=1763048824",
      top_notes: ["Apelsin", "Bergamott", "Grapefrukt"],
      heart_notes: ["Ros", "Jasmin", "Litchi"],
      base_notes: ["Patchouli", "Vanilj", "Mysk", "Vetiver"],
      description: "En fräsch och modern orientalisk doft.",
      year: "2001",
      gender: "Female",
      productNumbers: ["067", "139"]
    },
    {
      id: "chanel_no5",
      name: "No. 5",
      brand: "Chanel",
      image: "https://tryscent.co/cdn/shop/files/Chanel_N_5.avif?v=1763048692",
      top_notes: ["Aldehyder", "Ylang-Ylang", "Neroli", "Bergamott"],
      heart_notes: ["Iris", "Jasmin", "Ros", "Liljekonvalj"],
      base_notes: ["Vanilj", "Amber", "Sandelträ", "Vetiver", "Mysk"],
      description: "Världens mest legendariska doft.",
      year: "1921",
      gender: "Female",
      productNumbers: ["077"]
    },
    {
      id: "chanel_chance",
      name: "Chance",
      brand: "Chanel",
      image: "https://tryscent.co/cdn/shop/files/Chance_Eau_de_Parfum.webp?v=1772210831",
      top_notes: ["Rosa Peppar", "Kvitten", "Citrus"],
      heart_notes: ["Hyacint", "Jasmin", "Iris"],
      base_notes: ["Mysk", "Patchouli", "Vetiver", "Ceder"],
      description: "En livlig och oväntad blommig doft.",
      year: "2003",
      gender: "Female",
      productNumbers: ["006"]
    },
    {
      id: "chanel_coco",
      name: "Coco",
      brand: "Chanel",
      image: "https://tryscent.co/cdn/shop/files/Chanel_Coco_Mademoiselle.avif?v=1763048824",
      top_notes: ["Koriander", "Mandarin", "Persika", "Jasmin"],
      heart_notes: ["Ros", "Kryddnejlika", "Mimosa", "Nelke"],
      base_notes: ["Sandelträ", "Amber", "Opium", "Benzoin"],
      description: "En frodig och sinnlig orientalisk doft.",
      year: "1984",
      gender: "Female",
      productNumbers: ["079"]
    }
  ],

  // ===== DIOR =====
  dior: [
    {
      id: "dior_sauvage",
      name: "Sauvage",
      brand: "Dior",
      image: "https://tryscent.co/cdn/shop/files/Dior_Sauvage.avif?v=1763049794",
      top_notes: ["Bergamott", "Peppar", "Ambroxan"],
      heart_notes: ["Lavendel", "Ingefära", "Elemi"],
      base_notes: ["Amber", "Ceder", "Vetiver"],
      description: "En frisk, kraftfull och vild doft som symboliserar frihet och maskulinitet.",
      year: "2015",
      gender: "Male",
      productNumbers: ["230", "338"]
    },
    {
      id: "dior_sauvage_elixir",
      name: "Sauvage Elixir",
      brand: "Dior",
      image: "https://tryscent.co/cdn/shop/files/Sauvage_Elixir.jpg?v=1763008549",
      top_notes: ["Grapefrukt", "Muskot", "Kanel"],
      heart_notes: ["Lavendel", "Stjärnanis", "Koriander"],
      base_notes: ["Lakrits", "Patchouli", "Sandelträ"],
      description: "En djärv och intensiv nytolkning av den ikoniska Sauvage-doften.",
      year: "2021",
      gender: "Male",
      productNumbers: ["366"]
    },
    {
      id: "dior_fahrenheit",
      name: "Fahrenheit",
      brand: "Dior",
      image: "https://tryscent.co/cdn/shop/files/Dior_Fahrenheit.avif?v=1763049040",
      top_notes: ["Viol", "Läder", "Rökelse"],
      heart_notes: ["Läder", "Viol", "Kaprifol"],
      base_notes: ["Läder", "Vetiver", "Amber", "Myrra"],
      description: "En revolutionerande doft som förenar blommiga, träiga och läderartade noter.",
      year: "1988",
      gender: "Male",
      productNumbers: ["206", "350"]
    },
    {
      id: "dior_jadore",
      name: "J'adore",
      brand: "Dior",
      image: "https://tryscent.co/cdn/shop/files/Dior_J_adore.avif?v=1763048984",
      top_notes: ["Päron", "Melon", "Persika", "Magnolia"],
      heart_notes: ["Jasmin", "Ros", "Liljekonvalj", "Ylang-Ylang"],
      base_notes: ["Vanilj", "Mysk", "Ceder"],
      description: "En blommig bukett av exceptionell rikedom.",
      year: "1999",
      gender: "Female",
      productNumbers: ["159"]
    },
    {
      id: "dior_hypnotic_poison",
      name: "Hypnotic Poison",
      brand: "Dior",
      image: "https://tryscent.co/cdn/shop/files/Dior_Hypnotic_Poison.avif?v=1763046742",
      top_notes: ["Aprikos", "Plommon", "Kokos", "Bittermandel"],
      heart_notes: ["Ros", "Jasmin", "Liljekonvalj"],
      base_notes: ["Vanilj", "Mandel", "Mysk"],
      description: "En mystisk och sinnlig doft.",
      year: "1998",
      gender: "Female",
      productNumbers: ["145"]
    },
    {
      id: "dior_miss_dior",
      name: "Miss Dior",
      brand: "Dior",
      image: "https://tryscent.co/cdn/shop/files/Dior_Miss_Dior_Le_Parfum.png?v=1771367270",
      top_notes: ["Lavendel", "Bergamott", "Salvia"],
      heart_notes: ["Iris", "Mysk", "Ambrette", "Päron"],
      base_notes: ["Ceder", "Vetiver", "Läder", "Amber"],
      description: "Den mest koncentrerade och lyxiga versionen av Miss Dior.",
      year: "2017",
      gender: "Female",
      productNumbers: ["196"]
    },
    {
      id: "dior_miss_dior_le_parfum",
      name: "Miss Dior Le Parfum",
      brand: "Dior",
      image: "https://tryscent.co/cdn/shop/files/Dior_Miss_Dior_Le_Parfum.png?v=1771367270",
      top_notes: ["Mandarin", "Citrus", "Bergamott"],
      heart_notes: ["Turkisk ros", "Bulgarisk ros", "Jasmin"],
      base_notes: ["Amber", "Patchouli", "Vanilj", "Träiga noter"],
      description: "En sensuell och elegant orientalisk-chypre doft som kombinerar blommiga ackord med varma träiga toner. Denna koncentrerade version av Miss Dior erbjuder en djup, rik och förförisk upplevelse med mandarin i toppen, rosor i hjärtat och en bas av amber, patchouli och vanilj. Perfekt för kvällar och speciella tillfällen.",
      year: "2012",
      gender: "Female",
      productNumbers: ["196"]
    },
    {
      id: "dior_miss_cherie",
      name: "Miss Chérie",
      brand: "Dior",
      image: "https://tryscent.co/cdn/shop/files/Dior_Miss_Dior_Cherie.webp?v=1772223859",
      top_notes: ["Jordgubbe", "Mandarin", "Rosa Peppar"],
      heart_notes: ["Jasmin", "Ros", "Karamell", "Popcorn"],
      base_notes: ["Patchouli", "Mysk", "Ceder"],
      description: "En lekfull och romantisk doft.",
      year: "2005",
      gender: "Female",
      productNumbers: ["082"]
    },
    {
      id: "dior_homme_intense",
      name: "Dior Homme Intense",
      brand: "Dior",
      image: "https://tryscent.co/cdn/shop/files/Dior_Homme_Intense.webp?v=1772214611",
      top_notes: ["Lavendel"],
      heart_notes: ["Iris", "Amber", "Kakao"],
      base_notes: ["Läder", "Ceder", "Vetiver"],
      description: "En raffinerad och kraftfull tolkning av Dior Homme.",
      year: "2011",
      gender: "Male",
      productNumbers: ["277"]
    }
  ],

  // ===== LANCOME =====
  lancome: [
    {
      id: "lancome_la_vie_est_belle",
      name: "La Vie Est Belle",
      brand: "Lancôme",
      image: "https://tryscent.co/cdn/shop/files/Lancome_La_Vie_Est_Belle_6045969c-df9c-4de9-a9eb-e1a8a7b8cf1f.avif?v=1763048752",
      top_notes: ["Svarta vinbär", "Päron", "Apelsinblomma"],
      heart_notes: ["Iris", "Jasmin", "Apelsinblomma"],
      base_notes: ["Pralin", "Vanilj", "Patchouli", "Tonka"],
      description: "En strålande och glädjefylld doft.",
      year: "2012",
      gender: "Female",
      productNumbers: ["412", "101"]
    },
    {
      id: "lancome_tresor",
      name: "Trésor",
      brand: "Lancôme",
      image: "https://tryscent.co/cdn/shop/files/tresor.webp?v=1772213134",
      top_notes: ["Persika", "Aprikos", "Ros"],
      heart_notes: ["Liljekonvalj", "Jasmin", "Iris"],
      base_notes: ["Vanilj", "Sandelträ", "Mysk"],
      description: "En romantisk och tidlös doft.",
      year: "1990",
      gender: "Female",
      productNumbers: ["141"]
    }
  ],

  // ===== NARCISO RODRIGUEZ =====
  narciso: [
    {
      id: "narciso_for_her",
      name: "For Her",
      brand: "Narciso Rodriguez",
      image: "https://tryscent.co/cdn/shop/files/Narciso_Rodriguez_Musc_Noir_for_Her.webp?v=1772223687",
      top_notes: ["Plommon", "Bergamott", "Mandarin"],
      heart_notes: ["Tuberos", "Jasmin", "Mysk"],
      base_notes: ["Patchouli", "Vanilj", "Ceder"],
      description: "En sensuell och mystisk doft som hyllar myskets kraft.",
      year: "2003",
      gender: "Female",
      productNumbers: ["457"]
    },    
  ],

  // ===== PACO RABANNE =====
  pacoRabanne: [
    {
      id: "paco_one_million",
      name: "1 Million",
      brand: "Paco Rabanne",
      image: "https://tryscent.co/cdn/shop/files/Paco_Rabanne_One_Million.avif?v=1763008490",
      top_notes: ["Grapefrukt", "Mynta", "Mandarin"],
      heart_notes: ["Kanel", "Ros", "Kryddor"],
      base_notes: ["Läder", "Amber", "Patchouli"],
      description: "En djärv och förförisk doft för mannen som känner sitt värde.",
      year: "2008",
      gender: "Male",
      productNumbers: ["275"]
    },
    {
      id: "paco_one_million_elixir",
      name: "1 Million Elixir",
      brand: "Paco Rabanne",
      image: "https://tryscent.co/cdn/shop/files/1_Million_Elixir.webp?v=1772215569",
      top_notes: ["Grapefrukt", "Mandarin", "Mynta"],
      heart_notes: ["Kanel", "Ros", "Saffran"],
      base_notes: ["Läder", "Amber", "Vanilj", "Patchouli"],
      description: "En intensivare och mer koncentrerad version av den ikoniska 1 Million.",
      year: "2020",
      gender: "Male",
      productNumbers: ["334"]
    },
    {
      id: "paco_invictus",
      name: "Invictus",
      brand: "Paco Rabanne",
      image: "https://tryscent.co/cdn/shop/files/Invictus.webp?v=1772212081",
      top_notes: ["Grapefrukt", "Mandarin", "Havsnoter"],
      heart_notes: ["Lagerblad", "Jasmin", "Ceder"],
      base_notes: ["Ekmossa", "Amber", "Patchouli"],
      description: "En frisk och kraftfull doft för den segerrike mannen.",
      year: "2013",
      gender: "Male",
      productNumbers: ["228"]
    },
    {
      id: "paco_phantom",
      name: "Phantom",
      brand: "Paco Rabanne",
      image: "https://tryscent.co/cdn/shop/files/phantom.webp?v=1772215500",
      top_notes: ["Citron", "Bergamott", "Lavendel"],
      heart_notes: ["Salvia", "Vetiver", "Patchouli"],
      base_notes: ["Vanilj", "Amber", "Ceder"],
      description: "En futuristisk och uppkopplad doft för en ny generation.",
      year: "2021",
      gender: "Male",
      productNumbers: ["399"]
    },
    {
      id: "paco_lady_million",
      name: "Lady Million",
      brand: "Paco Rabanne",
      image: "https://tryscent.co/cdn/shop/files/Paco_Rabanne_Lady_Million.avif?v=1763048720",
      top_notes: ["Hallon", "Neroli", "Citron"],
      heart_notes: ["Apelsinblomma", "Jasmin", "Honung"],
      base_notes: ["Patchouli", "Amber", "Ceder"],
      description: "En strålande och glamourös doft för den moderna kvinnan.",
      year: "2010",
      gender: "Female",
      productNumbers: ["023"]
    },
    {
      id: "paco_fame",
      name: "Fame",
      brand: "Paco Rabanne",
      image: "https://tryscent.co/cdn/shop/files/fame.webp?v=1772210136",
      top_notes: ["Mango", "Bergamott", "Mandarin"],
      heart_notes: ["Jasmin", "Ros", "Rökelse"],
      base_notes: ["Sandelträ", "Vanilj", "Mysk"],
      description: "En livlig och modern doft.",
      year: "2022",
      gender: "Female",
      productNumbers: ["498"]
    }
  ],

  // ===== JEAN PAUL GAULTIER =====
  jpg: [
    {
      id: "jpg_le_male",
      name: "Le Male",
      brand: "Jean Paul Gaultier",
      image: "https://tryscent.co/cdn/shop/files/Le_Male_Jean_Paul_Gaultier.avif?v=1763048520",
      top_notes: ["Mynta", "Lavendel", "Bergamott", "Kardemumma"],
      heart_notes: ["Kanel", "Apelsinblomma", "Kummin"],
      base_notes: ["Vanilj", "Tonka", "Amber", "Ceder"],
      description: "En ikonisk och förförisk doft för den moderna mannen.",
      year: "1995",
      gender: "Male",
      productNumbers: ["247"]
    },
    {
      id: "jpg_ultra_male",
      name: "Ultra Male",
      brand: "Jean Paul Gaultier",
      image: "https://tryscent.co/cdn/shop/files/ultra_male.webp?v=1772214378",
      top_notes: ["Päron", "Mynta", "Lavendel"],
      heart_notes: ["Kanel", "Salvia", "Muskatellsalvia"],
      base_notes: ["Vanilj", "Amber", "Tränoter"],
      description: "En kraftfull och förförisk doft som tänjer på gränserna för maskulinitet.",
      year: "2015",
      gender: "Male",
      productNumbers: ["349"]
    },
    {
      id: "jpg_la_belle",
      name: "La Belle",
      brand: "Jean Paul Gaultier",
      image: "https://tryscent.co/cdn/shop/files/la_belle.webp?v=1772211142",
      top_notes: ["Päron", "Bergamott"],
      heart_notes: ["Jasmin", "Apelsinblomma"],
      base_notes: ["Vanilj", "Tonka", "Ceder"],
      description: "En förförisk och beroendeframkallande gourmand-doft.",
      year: "2019",
      gender: "Female",
      productNumbers: ["412"]
    },
    {
      id: "jpg_classique",
      name: "Classique",
      brand: "Jean Paul Gaultier",
      image: "https://tryscent.co/cdn/shop/files/Jean_Paul_Gaultier_Classique_Essence.webp?v=1772211913",
      top_notes: ["Ros", "Ingefära", "Bergamott"],
      heart_notes: ["Tuberos", "Jasmin", "Apelsinblomma"],
      base_notes: ["Vanilj", "Amber", "Mysk"],
      description: "En intensivare tolkning av Classique.",
      year: "2013",
      gender: "Female",
      productNumbers: ["442"]
    }
  ],

  // ===== MUGLER =====
  mugler: [
    {
      id: "mugler_alien",
      name: "Alien",
      brand: "Mugler",
      image: "https://tryscent.co/cdn/shop/files/Mugler_Alien.avif?v=1763049213",
      top_notes: ["Jasmin", "Amber"],
      heart_notes: ["Tränoter", "Mysk"],
      base_notes: ["Vanilj", "Ceder"],
      description: "En mystisk och sensuell doft.",
      year: "2005",
      gender: "Female",
      productNumbers: ["004"]
    },
    {
      id: "mugler_angel",
      name: "Angel",
      brand: "Mugler",
      image: "https://tryscent.co/cdn/shop/files/angel.webp?v=1772215369",
      top_notes: ["Sockervadd", "Bergamott", "Ananas", "Kokos"],
      heart_notes: ["Honung", "Röda bär", "Persika", "Plommon", "Aprikos"],
      base_notes: ["Patchouli", "Vanilj", "Choklad", "Karamell"],
      description: "En revolutionerande gourmand-doft.",
      year: "1992",
      gender: "Female",
      productNumbers: ["113"]
    }
  ],

  // ===== CHLOE =====
  chloe: [
    {
      id: "chloe_chloe",
      name: "Chloé",
      brand: "Chloé",
      image: "https://tryscent.co/cdn/shop/files/Chloe.webp?v=1772211730",
      top_notes: ["Pion", "Litchi", "Freesia"],
      heart_notes: ["Magnolia", "Ros", "Liljekonvalj"],
      base_notes: ["Ceder", "Amber", "Mysk"],
      description: "En fräsch och elegant rosdoft.",
      year: "2008",
      gender: "Female",
      productNumbers: ["024"]
    },
    {
      id: "chloe_nomade",
      name: "Nomade",
      brand: "Chloé",
      image: "https://tryscent.co/cdn/shop/files/Nomade.webp?v=1772224097",
      top_notes: ["Mirabell", "Citron", "Bergamott"],
      heart_notes: ["Freesia", "Jasmin", "Ros"],
      base_notes: ["Ekmossa", "Sandelträ", "Amber"],
      description: "En fri och äventyrlig doft.",
      year: "2018",
      gender: "Female",
      productNumbers: ["049"]
    }
  ],

  // ===== GIORGIO ARMANI =====
  armani: [
    {
      id: "armani_acqua_di_gio",
      name: "Acqua di Gio",
      brand: "Giorgio Armani",
      image: "https://tryscent.co/cdn/shop/files/Giorgio_Armani_Acqua_di_Gio.avif?v=1763048569",
      top_notes: ["Bergamott", "Neroli", "Grön Mandarin"],
      heart_notes: ["Jasmin", "Rosmarin", "Salvia"],
      base_notes: ["Ceder", "Patchouli", "Mysk"],
      description: "En tidlös akvatisk klassiker som fångar Medelhavets essens.",
      year: "1996",
      gender: "Male",
      productNumbers: ["221"]
    },
    {
      id: "armani_code",
      name: "Armani Code",
      brand: "Giorgio Armani",
      image: "https://tryscent.co/cdn/shop/files/armani_code.webp?v=1772215229",
      top_notes: ["Bergamott", "Citron", "Gröna noter"],
      heart_notes: ["Olivblomma", "Jasmin", "Apelsinblomma"],
      base_notes: ["Läder", "Ceder", "Tonka"],
      description: "En sofistikerad och förförisk doft för den moderna mannen.",
      year: "2004",
      gender: "Male",
      productNumbers: ["260"]
    },
    {
      id: "armani_stronger_with_you_intensely",
      name: "Stronger With You Intensely",
      brand: "Giorgio Armani",
      image: "https://tryscent.co/cdn/shop/files/Giorgio_Armani_Stronger_With_You_Intensely.avif?v=1763048470",
      top_notes: ["Rosa Peppar", "Kardemumma", "Violblad"],
      heart_notes: ["Salvia", "Lavendel", "Kanel"],
      base_notes: ["Vanilj", "Kastanj", "Tonka", "Amber"],
      description: "En intensivare och kraftfullare tolkning av Stronger With You.",
      year: "2019",
      gender: "Male",
      productNumbers: ["318"]
    },
    {
      id: "armani_emporio_he",
      name: "Emporio He",
      brand: "Giorgio Armani",
      image: "https://tryscent.co/cdn/shop/files/Emporio_Armani_He.webp?v=1772216199",
      top_notes: ["Bergamott", "Mandarin", "Citron"],
      heart_notes: ["Jasmin", "Rosmarin", "Salvia"],
      base_notes: ["Ceder", "Sandelträ", "Mysk", "Amber"],
      description: "En frisk och maskulin doft för den moderna mannen som kombinerar citrus med träiga toner.",
      year: "1998",
      gender: "Male",
      productNumbers: ["242"]
    },
    {
      id: "armani_si",
      name: "Si",
      brand: "Giorgio Armani",
      image: "https://tryscent.co/cdn/shop/files/Giorgio_Armani_Si.avif?v=1763049011",
      top_notes: ["Svarta vinbär", "Päron", "Mandarin"],
      heart_notes: ["Ros", "Freesia", "Liljekonvalj"],
      base_notes: ["Vanilj", "Patchouli", "Benzoin"],
      description: "En sofistikerad och modern chypre-doft.",
      year: "2013",
      gender: "Female",
      productNumbers: ["129"]
    },
    {
      id: "armani_my_way",
      name: "My Way",
      brand: "Giorgio Armani",
      image: "https://tryscent.co/cdn/shop/files/Giorgio_Armani_MY_WAY.webp?v=1772210531",
      top_notes: ["Apelsinblomma", "Bergamott"],
      heart_notes: ["Tuberos", "Jasmin"],
      base_notes: ["Vanilj", "Ceder", "Vit Mysk"],
      description: "En strålande och etisk doft.",
      year: "2020",
      gender: "Female",
      productNumbers: ["140"]
    },
    {
      id: "armani_code_for_women",
      name: "Code for Women",
      brand: "Giorgio Armani",
      image: "https://tryscent.co/cdn/shop/files/Armani_Code_for_Women.webp?v=1772214161",
      top_notes: ["Apelsinblomma", "Jasmin", "Bergamott"],
      heart_notes: ["Honung", "Mandel", "Ingefära"],
      base_notes: ["Vanilj", "Sandelträ", "Mysk"],
      description: "En förförisk och elegant orientalisk blommig doft.",
      year: "2006",
      gender: "Female",
      productNumbers: ["135"]
    },
    {
      id: "armani_diamonds",
      name: "Armani Diamonds",
      brand: "Giorgio Armani",
      image: "https://tryscent.co/cdn/shop/files/Armani_Diamonds.webp?v=1772215941",
      top_notes: ["Mandarin", "Bergamott", "Apelsin"],
      heart_notes: ["Ros", "Jasmin", "Ylang-Ylang"],
      base_notes: ["Sandelträ", "Mysk", "Amber"],
      description: "En gnistrande och elegant doft.",
      year: "2000",
      gender: "Female",
      productNumbers: ["040"]
    },
    {
      id: "armani_emporio_she",
      name: "Emporio She",
      brand: "Giorgio Armani",
      image: "https://tryscent.co/cdn/shop/files/Emporio_Armani_She.webp?v=1772223983",
      top_notes: ["Citron", "Bergamott", "Ros"],
      heart_notes: ["Jasmin", "Pion", "Liljekonvalj"],
      base_notes: ["Sandelträ", "Mysk", "Vanilj"],
      description: "En frisk och feminin doft.",
      year: "1998",
      gender: "Female",
      productNumbers: ["150"]
    }
  ],

  // ===== HUGO BOSS =====
  hugoBoss: [
    {
      id: "boss_bottled",
      name: "Boss Bottled",
      brand: "Hugo Boss",
      image: "https://tryscent.co/cdn/shop/files/Hugo_Boss_Boss_Bottled.avif?v=1763048407",
      top_notes: ["Äpple", "Citrus", "Geranium"],
      heart_notes: ["Ceder", "Sandelträ", "Patchouli"],
      base_notes: ["Vanilj", "Mysk", "Amber"],
      description: "En klassisk och sofistikerad doft för den framgångsrika moderna mannen.",
      year: "1998",
      gender: "Male",
      productNumbers: ["234"]
    },
    {
      id: "boss_the_scent",
      name: "The Scent",
      brand: "Hugo Boss",
      image: "https://tryscent.co/cdn/shop/files/Boss_The_Scent.webp?v=1772214490",
      top_notes: ["Ingefära", "Bergamott", "Mandarin"],
      heart_notes: ["Lavendel", "Maninka", "Fruktnoter"],
      base_notes: ["Läder", "Patchouli", "Ceder"],
      description: "En förförisk och magnetisk doft.",
      year: "2015",
      gender: "Male",
      productNumbers: ["184", "270"]
    },
    {
      id: "boss_hugo",
      name: "Hugo",
      brand: "Hugo Boss",
      image: "https://tryscent.co/cdn/shop/files/Hugo_Boss_Boss_Bottled.avif?v=1763048407",
      top_notes: ["Gröna noter", "Basilika", "Mynta"],
      heart_notes: ["Lavendel", "Geranium", "Muskatellsalvia"],
      base_notes: ["Ceder", "Sandelträ", "Mysk"],
      description: "En frisk och energisk doft för den unga och dynamiska mannen.",
      year: "1995",
      gender: "Male",
      productNumbers: ["223"]
    },
    {
      id: "boss_alive",
      name: "Alive",
      brand: "Hugo Boss",
      image: "https://tryscent.co/cdn/shop/files/Boss_Alive.webp?v=1772214289",
      top_notes: ["Äpple", "Svarta vinbär", "Plommon"],
      heart_notes: ["Ros", "Jasmin", "Kanel"],
      base_notes: ["Vanilj", "Mysk", "Ceder"],
      description: "En livlig och energisk doft.",
      year: "2019",
      gender: "Female",
      productNumbers: ["098"]
    },
    {
      id: "boss_ma_vie",
      name: "Ma Vie",
      brand: "Hugo Boss",
      image: "https://tryscent.co/cdn/shop/files/Hugo_Boss_Ma_Vie.webp?v=1772216304",
      top_notes: ["Citrus", "Fruktnoter", "Bergamott"],
      heart_notes: ["Ros", "Jasmin", "Liljekonvalj"],
      base_notes: ["Vanilj", "Mysk", "Ceder"],
      description: "En fräsch och elegant doft.",
      year: "2010",
      gender: "Female",
      productNumbers: ["058"]
    },
    {
      id: "boss_woman",
      name: "Boss Woman",
      brand: "Hugo Boss",
      image: "https://tryscent.co/cdn/shop/files/Boss_Woman.webp?v=1772212460",
      top_notes: ["Mandarin", "Äpple", "Persika"],
      heart_notes: ["Ros", "Jasmin", "Lilja"],
      base_notes: ["Sandelträ", "Mysk", "Vanilj"],
      description: "En klassisk och elegant doft.",
      year: "2000",
      gender: "Female",
      productNumbers: ["060"]
    },
    {
      id: "boss_orange",
      name: "Boss Orange",
      brand: "Hugo Boss",
      image: "https://tryscent.co/cdn/shop/files/Boss_Orange.webp?v=1772215682",
      top_notes: ["Äpple", "Vita blommor", "Citrus"],
      heart_notes: ["Ros", "Jasmin", "Pion"],
      base_notes: ["Sandelträ", "Mysk", "Vanilj"],
      description: "En fräsch och bekymmersfri doft.",
      year: "2003",
      gender: "Female",
      productNumbers: ["148"]
    },
    {
      id: "boss_deep_red",
      name: "Deep Red",
      brand: "Hugo Boss",
      image: "https://tryscent.co/cdn/shop/files/deep_red.webp?v=1772223281",
      top_notes: ["Svarta vinbär", "Mandarin", "Rosa Peppar"],
      heart_notes: ["Ros", "Jasmin", "Apelsinblomma"],
      base_notes: ["Patchouli", "Vanilj", "Ceder"],
      description: "En livlig och passionerad doft.",
      year: "2006",
      gender: "Female",
      productNumbers: ["022"]
    }
  ],

  // ===== CALVIN KLEIN =====
  calvinKlein: [
    {
      id: "ck_one",
      name: "CK One",
      brand: "Calvin Klein",
      image: "https://tryscent.co/cdn/shop/files/CK_One.webp?v=1772137544",
      top_notes: ["Bergamott", "Citron", "Gröna noter"],
      heart_notes: ["Jasmin", "Ros", "Liljekonvalj"],
      base_notes: ["Mysk", "Amber", "Ceder"],
      description: "En ikonisk unisex-doft som symboliserar friskhet och renhet.",
      year: "1994",
      gender: "Unisex",
      productNumbers: ["209"]
    },
    {
      id: "ck_eternity_men",
      name: "Eternity for Men",
      brand: "Calvin Klein",
      image: "https://tryscent.co/cdn/shop/files/Eternity.webp?v=1772215798",
      top_notes: ["Lavendel", "Bergamott", "Citron"],
      heart_notes: ["Koriander", "Jasmin", "Geranium"],
      base_notes: ["Sandelträ", "Mysk", "Amber"],
      description: "En tidlös och romantisk doft för män.",
      year: "1990",
      gender: "Male",
      productNumbers: ["215"]
    },
    {
      id: "ck_eternity_women",
      name: "Eternity for Women",
      brand: "Calvin Klein",
      image: "https://tryscent.co/cdn/shop/files/Eternity.webp?v=1772215798",
      top_notes: ["Mandarin", "Bergamott", "Citron"],
      heart_notes: ["Liljekonvalj", "Ros", "Jasmin"],
      base_notes: ["Sandelträ", "Mysk", "Amber"],
      description: "En tidlös och romantisk doft för kvinnor.",
      year: "1988",
      gender: "Female",
      productNumbers: ["106"]
    }
  ],

  // ===== DOLCE & GABBANA =====
  dolceGabbana: [
    {
      id: "dolce_light_blue",
      name: "Light Blue",
      brand: "Dolce & Gabbana",
      image: "https://tryscent.co/cdn/shop/files/Dolce_Gabbana_Light_Blue.jpg",
      top_notes: ["Siciliansk citron", "Äpple", "Ceder"],
      heart_notes: ["Jasmin", "Vit ros", "Bambu"],
      base_notes: ["Ceder", "Amber", "Mysk"],
      description: "En fräsch och solig doft som fångar Medelhavets essens.",
      year: "2001",
      gender: "Female",
      productNumbers: ["017"]
    },
    {
      id: "dolce_the_one",
      name: "The One",
      brand: "Dolce & Gabbana",
      image: "https://tryscent.co/cdn/shop/files/The_One_Royal_Night.webp?v=1772223473",
      top_notes: ["Persika", "Litchi", "Mandarin"],
      heart_notes: ["Ros", "Jasmin", "Lilja"],
      base_notes: ["Vanilj", "Amber", "Mysk"],
      description: "En sofistikerad och sensuell doft.",
      year: "2006",
      gender: "Female",
      productNumbers: ["094"]
    }
  ],

  // ===== GIVENCHY =====
  givenchy: [
    {
      id: "givenchy_ange_ou_demon",
      name: "Ange ou Démon",
      brand: "Givenchy",
      image: "https://tryscent.co/cdn/shop/files/Givenchy_Ange_Ou_Demon.webp?v=1772216079",
      top_notes: ["Saffran", "Ylang-Ylang", "Lilja"],
      heart_notes: ["Ros", "Jasmin", "Apelsinblomma"],
      base_notes: ["Vanilj", "Sandelträ", "Patchouli"],
      description: "En mystisk och förförisk doft.",
      year: "2006",
      gender: "Female",
      productNumbers: ["142"]
    }
  ],

  // ===== KENZO =====
  kenzo: [
    {
      id: "kenzo_flower",
      name: "Flower by Kenzo",
      brand: "Kenzo",
      image: "https://tryscent.co/cdn/shop/files/Flower_by_Kenzo.webp?v=1772214555",
      top_notes: ["Hagtorn", "Svarta vinbär", "Mandarin"],
      heart_notes: ["Ros", "Jasmin", "Viol"],
      base_notes: ["Vanilj", "Mysk", "Ceder"],
      description: "En poetisk och ömtålig doft.",
      year: "2000",
      gender: "Female",
      productNumbers: ["074"]
    }
  ],

  // ===== HERMÈS =====
  hermes: [
    {
      id: "hermes_terre",
      name: "Terre d'Hermès",
      brand: "Hermès",
      image: "https://tryscent.co/cdn/shop/files/Hermes_Terre_d_Hermes.avif?v=1763047220",
      top_notes: ["Apelsin", "Grapefrukt"],
      heart_notes: ["Peppar", "Pelargon"],
      base_notes: ["Vetiver", "Ceder", "Patchouli"],
      description: "En kraftfull och originell doft som hyllar jorden.",
      year: "2006",
      gender: "Male",
      productNumbers: ["227"]
    }
  ],

  // ===== DAVIDOFF =====
  davidoff: [
    {
      id: "davidoff_cool_water",
      name: "Cool Water",
      brand: "Davidoff",
      image: "https://tryscent.co/cdn/shop/files/Davidoff_Cool_Water.avif?v=1763033348",
      top_notes: ["Havssalt", "Mynta", "Lavendel"],
      heart_notes: ["Pelargon", "Sandelträ", "Rosmarin"],
      base_notes: ["Mysk", "Ceder", "Tobak"],
      description: "En frisk och ren doft inspirerad av havets friskhet.",
      year: "1988",
      gender: "Male",
      productNumbers: ["200"]
    }
  ],

  // ===== JOOP! =====
  joop: [
    {
      id: "joop_homme",
      name: "Joop! Homme",
      brand: "Joop!",
      image: "https://tryscent.co/cdn/shop/files/Joop_Homme.webp?v=1772214918",
      top_notes: ["Kanel", "Bergamott", "Mandarin"],
      heart_notes: ["Liljekonvalj", "Jasmin", "Geranium"],
      base_notes: ["Sandelträ", "Vanilj", "Tonka", "Ceder"],
      description: "En kärleksfull, kryddig och förförisk doft.",
      year: "1989",
      gender: "Male",
      productNumbers: ["211"]
    }
  ],

  // ===== CREED =====
  creed: [
    {
      id: "creed_aventus",
      name: "Aventus",
      brand: "Creed",
      image: "https://tryscent.co/cdn/shop/files/creed_aventus.webp?v=1763008550",
      top_notes: ["Ananas", "Bergamott", "Svarta vinbär", "Äpple"],
      heart_notes: ["Björk", "Jasmin", "Patchouli", "Ros"],
      base_notes: ["Ekmossa", "Amber", "Vanilj", "Mysk"],
      description: "En legendarisk doft som hyllar styrka och framgång.",
      year: "2010",
      gender: "Male",
      productNumbers: ["288"]
    }
  ],

  // ===== VERSACE =====
  versace: [
    {
      id: "versace_eros",
      name: "Eros",
      brand: "Versace",
      image: "https://tryscent.co/cdn/shop/files/eros_versace.jpg?v=1763008550",
      top_notes: ["Mynta", "Grönt äpple", "Citron"],
      heart_notes: ["Tonka", "Ambrosia", "Geranium"],
      base_notes: ["Vanilj", "Ceder", "Ekmossa", "Patchouli"],
      description: "En intensiv, sensuell och förförisk doft inspirerad av den grekiska kärleksguden.",
      year: "2012",
      gender: "Male",
      productNumbers: ["248"]
    }
  ],

  // ===== BVLGARI =====
  bvlgari: [
    {
      id: "bvlgari_aqva",
      name: "Aqva Pour Homme",
      brand: "Bvlgari",
      image: "https://tryscent.co/cdn/shop/files/Bvlgari_Aqva.webp?v=1772214918",
      top_notes: ["Mandarin", "Neroli", "Petitgrain"],
      heart_notes: ["Vattennoter", "Salvia", "Lavendel"],
      base_notes: ["Mysk", "Amber", "Ceder"],
      description: "En fräsch och akvatisk doft inspirerad av Medelhavet.",
      year: "2005",
      gender: "Male",
      productNumbers: ["305"]
    }
  ],

  // ===== ADD INDEX FOR FAST SEARCHING =====
  _index: {}
};

// ===== BUILD SEARCH INDEX =====
(function buildIndex() {
  const catalog = window.SwedishPerfumeCatalog;
  for (let brandKey in catalog) {
    if (brandKey.startsWith('_')) continue;
    const perfumes = catalog[brandKey];
    if (Array.isArray(perfumes)) {
      perfumes.forEach(perfume => {
        if (perfume.id) {
          catalog._index[perfume.id] = perfume;
        }
      });
    }
  }
  console.log(`✅ SwedishPerfumeCatalog loaded with ${Object.keys(catalog._index).length} real perfumes`);
})();